module.exports = __webpack_public_path__ + "static/media/95 - The Undercover Dream Lovers - You Don't Have to be Lonely.6bc85635.mp3";